import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

// comList
import { RecoderComponent } from "./recoder/recoder.component";
import { InfoBoxComponent } from "./info-box/info-box.component";
import { AudioPlayComponent } from "./audio-play/audio-play.component";

// import other lib
import { CountdownModule } from "ngx-countdown";
import { TimmerCircleComponent } from "./timmer-circle/timmer-circle.component";
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { TranscribeRecoderComponent } from "./transcribe-recoder/transcribe-recoder.component";
import { AudioTimmerComponent } from "./audio-timmer/audio-timmer.component";
import { DeepGramComponent } from "./deepgram-recorder/deepgram-recorder.component";

export function playerFactory() {
  return player;
}

const comList = [
  RecoderComponent,
  InfoBoxComponent,
  AudioPlayComponent,
  TimmerCircleComponent,
  TranscribeRecoderComponent,
  DeepGramComponent,
];

@NgModule({
  declarations: [comList, AudioTimmerComponent],
  imports: [
    CommonModule,
    CountdownModule,
    LottieModule.forRoot({ player: playerFactory }),
  ],
  exports: [comList],
})
export class EvaluateQuestionModule {}
